import "./App.css";
import PageTitle from "./components/PageTitle";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import BookTable from "./components/BookTable";
import Slushee from "./components/Slushee";
import Application from "./components/Application";
import NotFound from "./components/NotFound";
import Franchise from "./components/Franchise";
import NewMenu from "./components/menu/Menu";
import HotDesserts from "./components/menu/HotDesserts";
import MobileApps from "./components/MobileApps";
import FindUs from "./components/FindUs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTitle />
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* <Route path="/menu" element={<Menu />} /> */}
          <Route path="/menu" element={<NewMenu />} />
          <Route path="/menu/hot-desserts" element={<HotDesserts />} />
          <Route path="/booktable" element={<BookTable />} />
          <Route path="/slushees" element={<Slushee />} />
          <Route path="/apply" element={<Application />} />
          <Route path="/partner" element={<Franchise />} />
          <Route path="/app" element={<MobileApps />} />
          <Route path="/find-us" element={<FindUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
